
import React from 'react';

interface TooltipHintProps {
  showTooltip: boolean;
}

export function TooltipHint({ showTooltip }: TooltipHintProps) {
  if (!showTooltip) return null;
  
  return (
    <div className="absolute -top-[85px] left-[calc(50%+50px)] transform -translate-x-1/2 z-10 transition-opacity duration-500">
      <img src="/lovable-uploads/92602c75-c4d9-4944-b19c-f951f36cd024.png" alt="Results info" className="max-w-[90px]" />
    </div>
  );
}
